import React from 'react';
import Notification from '../../Notification';
import UnreadMessageCounts from '../../../pages/Messaging/UnreadCount';

const useNotificationHandlers = ({
  setPanelContent,
  setOpenRightPanel,
  setIsNotificationPanel,
  setIsTreatmentsPanel,
  setPanelTitle,
  setnotificationCount,
  notifications,
  fetchNotifications,
  ACM,
  typeOfUser,
  unreadCounts,
  setUnreadCounts,
  user,
  patientData,
  patientsLoaded,
  isUserExists,
}) => {
  const handleShowNotifications = () => {
    setPanelContent(
      <Notification
        setnotificationCount={setnotificationCount}
        notifications={notifications}
        fetchNotifications={fetchNotifications}
        setOpenRightPanel={setOpenRightPanel}
      />
    );
    setOpenRightPanel(true);
    setIsNotificationPanel(true);
    setIsTreatmentsPanel(false);
    if (typeof setPanelTitle === 'function') {
      setPanelTitle('Notifications');
    }
  };

  const renderUnreadMessageCounts = () => {
    if (ACM[typeOfUser]?.unreadMessageCountsDoc) {
      if (patientsLoaded && isUserExists) {
        return (
          <UnreadMessageCounts
            unreadCounts={unreadCounts}
            setUnreadCounts={setUnreadCounts}
            user={user}
            typeOfUser={typeOfUser}
            patientData={patientData}
          />
        );
      }
    } else if (ACM[typeOfUser]?.unreadMessageCountsPat) {
      if (isUserExists) {
        return (
          <UnreadMessageCounts
            unreadCounts={unreadCounts}
            setUnreadCounts={setUnreadCounts}
            user={user}
            typeOfUser={typeOfUser}
          />
        );
      }
    }
    return null;
  };

  return {
    handleShowNotifications,
    renderUnreadMessageCounts,
  };
};

export default useNotificationHandlers; 